<template>
  <div class="row">
    <div class="col-12">
      <div class="card card-body">
        <div class="col-12 table-responsive">
          <table class="table table-hover table-sm table-bordered">
            <thead>
              <th>
                الاسم
              </th>
              <th>
                الجوال
              </th>
              <th>
                تاريخ الانضمام
              </th>
              <th>
                الخطة
              </th>
              <th>
                تاريخ انتهاء الاشتراك
              </th>
              <th>
                خيارات
              </th>
            </thead>
            <tbody>
              <tr v-for="device in users" :key="device._id">
                <td>
                  {{ device.name }}
                </td>
                <td>
                  {{ device.phone }}
                </td>
                <td>
                  {{ device.joindate }}
                </td>
                <td>
                  <span class="btn btn-sm btn-secondary" v-if="device.plan == 1">الفضية</span>
                  <span class="btn btn-sm btn-success" v-if="device.plan == 2">الذهبية</span>
                  <span class="btn btn-sm btn-primary" v-if="device.plan == 3">الالماسية</span>
                  <span class="btn btn-sm btn-outline-danger" v-if="device.plan == 0">لم يشترك</span>
                  <a href="javascript:;" class="fa fa-edit" @click="edit(device._id, 'plan', device.plan)"></a>
                </td>
                <td>
                  {{ device.exdate }}
                  <a href="javascript:;" class="fa fa-edit" @click="edit(device._id, 'exdate', device.exdate)"></a>
                </td>
                <td>
                  <button class="fa fa-key btn btn-sm btn-info" @click="alertx(device.password)"></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      user: JSON.parse(localStorage.getItem('user')),
      users: []
    }
  },
  methods: {
    alertx(r){alert(r)},
    edit(id, input, value){
        var g = this;
        var p = prompt(input, value);
        if(p && p != ""){
            $.post(api + '/admin/users/edit', {
                jwt: this.user.jwt,
                id: id,
                input: input,
                value: p
            }).then(function(r){
                g.loading = false
                if(r.status != 100){
                    alert(r.response)
                }else{
                    location.reload()
                }
            }).fail(function(){
                g.loading = false
            })
        }
    }
  },
  created(){
    var g = this;
    $.post(api + '/admin/users', {
        jwt: this.user.jwt
    }).then(function(r){
        g.loading = false
        if(r.status != 100){
            alert(r.response)
        }else{
            g.users = r.response
        }
    }).fail(function(){
        g.loading = false
    })
  },
}
</script>

<style>

</style>